function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.889 1A3.888 3.888 0 001 4.889v6.222A3.888 3.888 0 004.889 15h6.222A3.888 3.888 0 0015 11.111V4.89C15 2.74 13.259 1 11.111 1H4.89zm7.778 1.556a.777.777 0 110 1.554.777.777 0 010-1.554zM8 4.11a3.89 3.89 0 11-.002 7.778A3.89 3.89 0 018 4.111zm0 1.556a2.333 2.333 0 100 4.664 2.333 2.333 0 000-4.663z",
  fill: "#FFF",
  fillRule: "nonzero"
});

function SvgInstagraminline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref);
}

export default SvgInstagraminline;